import { Div, Ref, Text } from "@tblabs/truffle";


export class InfoBox extends Div
{
    constructor(title: string, content: string | Ref<string>, theme: string = "#ead4a1")
    {
        super();

        this.Style(`display: block; margin: 32px 0; text-align: center;`);

        this.Append(
            new Div().Style(`display: inline-block; padding: 16px; text-align: left; border-left: 12px solid ${theme}`)
                .Append(
                    new Div().Text(title).TextAlignLeft().FontSize(20).MarginBottom(16).Color(theme),
                    new Text(content).Color("#ccc"),
                )
        );
    }
}

export class ErrorBox extends InfoBox
{
    constructor(title: string, content: string)
    {
        super(title, content, "#ff7795");
    }
}

export class SuccessBox extends InfoBox
{
    constructor(title: string, content: string)
    {
        super(title, content, "#90cf00");
    }
}
